module.exports = __webpack_public_path__ + "static/media/text_bg.61ff81e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Ideation/img/text_bg.png
// module id = 142
// module chunks = 0